<p-confirmDialog key="addportalnotification" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid2Col">
	<!--Apps-->
	<label>Send Notification to App(s):</label>
	<div class="CheckGrid">
		<input [disabled]="IsLoading() == true" id="ParentPortalSendNotification" class="CHK" type="checkbox" [(ngModel)]="ParentPortalSendNotification" />
		<label for="ParentPortalSendNotification">Parent Portal</label>

		<input
			[disabled]="IsLoading() == true"
			id="StudentPortalSendNotification"
			class="CHK InnerColumn"
			type="checkbox"
			[(ngModel)]="StudentPortalSendNotification"
		/>
		<label for="StudentPortalSendNotification">Student Portal</label>
	</div>

	<!--Message-->
	<label>Message:</label>
	<textarea class="TextArea" rows="5" [(ngModel)]="Message" maxlength="3000"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Send</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
